import {
  permissionsUsersReadonly,
  permissionsRolesReadonly,
  permissionsCompaniesReadonly,
  permissionsSubscriptionsReadonly,
  permissionsTenantsReadonly,
  permissionsPartnersReadonly,
  permissionsSettings,
  permissionsLocationsReadonly,
} from "@/utils";

export const permissionsSystemMenu = [
  ...permissionsUsersReadonly,
  ...permissionsRolesReadonly,
  ...permissionsCompaniesReadonly,
  ...permissionsPartnersReadonly,
  ...permissionsTenantsReadonly,
  ...permissionsSubscriptionsReadonly,
  ...permissionsSettings,
  ...permissionsLocationsReadonly,
];
